/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Ivetta Tkachenko <ivetta.tkachenko@opensoftdev.ru>
 */

define(['backbone'], function(backbone) {
    return backbone.Model.extend(
        {
            defaults: {
                strategy: null
            },

            getPrice: function() {
                return 0;
            }
        },
        {
            STRATEGY_FREE: 'free',
            STRATEGY_PRICE_PER_QUANTITY: 'price_per_quantity',
            STRATEGY_PRICE_PER_QUANTITY_PLUS_BASE: 'price_per_quantity_plus_base',
            STRATEGY_PERCENTAGE: 'percentage',
            STRATEGY_PERCENTAGE_SUB: 'percentage_sub',
            STRATEGY_SURCHARGE: 'surcharge'
        }
    );
});
